export default __webpack_public_path__ + "static/media/about-privacy-policy.cf65b89c.md";